var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_132137)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3172_132137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 16C28.1 22.6826 22.6826 28.1 16 28.1C9.31735 28.1 3.9 22.6826 3.9 16C3.9 9.31735 9.31735 3.9 16 3.9C22.6826 3.9 28.1 9.31735 28.1 16Z",
    stroke: "#6A66D9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.7496L11.875 13.3746H20.125L21.25 16.7496H10.75ZM20.125 20.4996C19.8266 20.4996 19.5405 20.3811 19.3295 20.1701C19.1185 19.9591 19 19.673 19 19.3746C19 19.0762 19.1185 18.7901 19.3295 18.5791C19.5405 18.3681 19.8266 18.2496 20.125 18.2496C20.4234 18.2496 20.7095 18.3681 20.9205 18.5791C21.1315 18.7901 21.25 19.0762 21.25 19.3746C21.25 19.673 21.1315 19.9591 20.9205 20.1701C20.7095 20.3811 20.4234 20.4996 20.125 20.4996ZM11.875 20.4996C11.5766 20.4996 11.2905 20.3811 11.0795 20.1701C10.8685 19.9591 10.75 19.673 10.75 19.3746C10.75 19.0762 10.8685 18.7901 11.0795 18.5791C11.2905 18.3681 11.5766 18.2496 11.875 18.2496C12.1734 18.2496 12.4595 18.3681 12.6705 18.5791C12.8815 18.7901 13 19.0762 13 19.3746C13 19.673 12.8815 19.9591 12.6705 20.1701C12.4595 20.3811 12.1734 20.4996 11.875 20.4996ZM21.19 12.9996C21.04 12.5646 20.62 12.2496 20.125 12.2496H11.875C11.38 12.2496 10.96 12.5646 10.81 12.9996L9.25 17.4996V23.4996C9.25 23.6985 9.32902 23.8893 9.46967 24.0299C9.61032 24.1706 9.80109 24.2496 10 24.2496H10.75C10.9489 24.2496 11.1397 24.1706 11.2803 24.0299C11.421 23.8893 11.5 23.6985 11.5 23.4996V22.7496H20.5V23.4996C20.5 23.6985 20.579 23.8893 20.7197 24.0299C20.8603 24.1706 21.0511 24.2496 21.25 24.2496H22C22.1989 24.2496 22.3897 24.1706 22.5303 24.0299C22.671 23.8893 22.75 23.6985 22.75 23.4996V17.4996L21.19 12.9996ZM12.25 10.7496C12.5484 10.7496 12.8345 10.6311 13.0455 10.4201C13.2565 10.2091 13.375 9.92298 13.375 9.62461C13.375 8.87461 12.25 7.59961 12.25 7.59961C12.25 7.59961 11.125 8.87461 11.125 9.62461C11.125 9.92298 11.2435 10.2091 11.4545 10.4201C11.6655 10.6311 11.9516 10.7496 12.25 10.7496ZM16 10.7496C16.2984 10.7496 16.5845 10.6311 16.7955 10.4201C17.0065 10.2091 17.125 9.92298 17.125 9.62461C17.125 8.87461 16 7.59961 16 7.59961C16 7.59961 14.875 8.87461 14.875 9.62461C14.875 9.92298 14.9935 10.2091 15.2045 10.4201C15.4155 10.6311 15.7016 10.7496 16 10.7496ZM19.75 10.7496C20.0484 10.7496 20.3345 10.6311 20.5455 10.4201C20.7565 10.2091 20.875 9.92298 20.875 9.62461C20.875 8.87461 19.75 7.59961 19.75 7.59961C19.75 7.59961 18.625 8.87461 18.625 9.62461C18.625 9.92298 18.7435 10.2091 18.9545 10.4201C19.1655 10.6311 19.4516 10.7496 19.75 10.7496Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3172_132137",
    x: -1,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3172_132137"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3172_132137",
    result: "effect2_dropShadow_3172_132137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3172_132137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_132137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/43f5c4b2cf1137b1e48ac435440f464d3bb6a68ce0.svg";
export { ForwardRef as ReactComponent };